module.exports = __webpack_public_path__ + "static/media/service-icon-2.d154c4dd.webp";